import { Box, Chip, Tooltip, IconButton } from "@mui/material";
import { colorsFoundation } from "@accredo/fe-shared/theme/tokens/colors-foundation.js";
import { Edit as EditIcon } from "@mui/icons-material";
import PropTypes from "prop-types";
import DataTable from "@accredo/fe-shared/components/DataTable.jsx";

const DOCUMENT_TYPES = [
  { value: "privacy", label: "Datenschutz" },
  { value: "terms", label: "Nutzungsbedingungen" },
];

const formatDate = (dateString) => {
  if (!dateString) return "-";
  return new Date(dateString).toLocaleDateString("de-DE");
};

const getDocumentTypeLabel = (type) => {
  const found = DOCUMENT_TYPES.find((t) => t.value === type);
  return found ? found.label : type;
};

const getVersionStatus = (row) => {
  if (!row.is_active) {
    return { label: "Inaktiv", color: colorsFoundation.label.grey };
  }
  const now = new Date();
  const from = row.effective_from ? new Date(row.effective_from) : null;
  const until = row.effective_until ? new Date(row.effective_until) : null;
  if (until && until < now) {
    return { label: "Abgelaufen", color: colorsFoundation.label.orange };
  }
  if (from && from > now) {
    return { label: "Geplant", color: colorsFoundation.label.blue };
  }
  return { label: "Aktiv", color: colorsFoundation.label.green };
};

const ConsentDocumentVersionsTable = ({ versions, isLoading, onEdit }) => {
  const columns = [
    {
      accessorKey: "document_type",
      header: "Typ",
      size: 150,
      Cell: ({ cell }) => (
        <Chip
          label={getDocumentTypeLabel(cell.getValue())}
          size="small"
          color={cell.getValue() === "privacy" ? "primary" : "secondary"}
        />
      ),
    },
    { accessorKey: "version", header: "Version", size: 100 },
    { accessorKey: "title", header: "Titel", size: 250 },
    {
      accessorKey: "effective_from",
      header: "Gültig ab",
      size: 120,
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: "effective_until",
      header: "Gültig bis",
      size: 120,
      Cell: ({ cell }) => formatDate(cell.getValue()),
    },
    {
      accessorKey: "is_active",
      header: "Status",
      size: 110,
      Cell: ({ row }) => {
        const status = getVersionStatus(row.original);
        return (
          <Chip
            label={status.label}
            size="small"
            variant="outlined"
            sx={{ backgroundColor: status.color, borderColor: "transparent" }}
          />
        );
      },
    },
    {
      accessorKey: "actions",
      header: "Aktionen",
      size: 80,
      enableSorting: false,
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <Tooltip title="Bearbeiten">
            <IconButton size="small" onClick={() => onEdit(row.original)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={versions}
      isLoading={isLoading}
      enableSorting={true}
      manualSorting={false}
      enablePagination={true}
      enableGlobalFilter={true}
      enableColumnFilters={true}
    />
  );
};

ConsentDocumentVersionsTable.propTypes = {
  versions: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  onEdit: PropTypes.func.isRequired,
};

export default ConsentDocumentVersionsTable;
